import { s3Uploader } from './s3_uploader';

export default function fileSelector(options) {
  const $img = options.uploadButton.siblings('.media-container.crop');
  options.uploadButton.off('click').click((e) => {
    e.preventDefault();
    if (s3Uploader.uploading) {
      return;
    }
    const $button = options.button;
    const currentButtonText = $button.text();
    s3Uploader.upload({
      contentTypes: options.contentTypes || 'image/*',
      beforeUpload: () => {
        $button.text('Uploading...');
      },
      type: options.type,
    }).then((resource) => {
      $img.removeClass('hide').css('background-image', `url('${resource.url}')`);
      options.uploadButton.siblings('span').addClass('hide');
      $button.text(currentButtonText);
      options.idInput.val(resource.id);
      if (typeof options.uploadCallback === 'function') {
        options.uploadCallback(resource);
      }
    }).catch(() => {
      $button.text(currentButtonText);
    });
  });
}
